<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="body">
            <div class="left">
                <div class="l_tit">官方评价维度</div>
                <div class="l_list">
                    <div class="ll_item" v-for="(item, index) in gfList" :key="index">
                        <div class="lli_top">
                            <img src="../../assets/img/i76.png" />
                            <div>{{ item.typeName }}</div>
                        </div>
                        <div class="lli_bottom">{{ item.typeExplain }}</div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="r_tit">创建评价维度</div>
                <div class="r_tit1">评价维度使用方法介绍文案</div>
                <div class="r_add" @click="openCreateWd">
                    <img src="../../assets/img/i77.png" />
                    创建维度
                </div>
                <div class="r_tit1">我创建的维度</div>
                <div class="r_list">
                    <div class="rl_item" v-for="(item, index) in wdList" :key="index">
                        <!-- <div class="menu" v-if="item.show">
                            <div class="m_item">
                                <img src="../../assets/img/i79.png" />
                                修改
                            </div>
                            <div class="m_item" style="border-top: 1px solid#F0F0F0;color: #DF2A3F;">
                                <img src="../../assets/img/i80.png" />
                                删除
                            </div>
                        </div> -->
                        <img class="rli_left" src="../../assets/img/i81.png" />
                        <div class="rli_right">
                            <div class="lir_top">
                                <div class="line1_">{{ item.typeName }}</div>
                                <img src="../../assets/img/i80.png" @click="btn_del(item.id)" />
                            </div>
                            <div class="lir_bottom">{{ item.typeExplain }}</div>
                        </div>
                    </div>
                    <div class="nodata" v-if="wdList.length == 0">
                        <img src="../../assets/img/i82.png" />
                        暂无评价维度
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { evaluateTypeOption, evaluateTypeAdd, evaluateTypeDelete } from '@/apis/index'

export default {
    data() {
        return {
            courseType: 1,
            gfList: [],
            wdList: []
        }
    },
    watch: {
        '$route.query.courseType'(newVal) {
            this.courseType = this.$route.query.courseType
            this.getEvaluateTypeOptionGF()
            this.getEvaluateTypeOption()
        }
    },
    created() {
        if (this.$route.query.courseType) {
            this.courseType = this.$route.query.courseType
        }
    },
    mounted() {
        this.getEvaluateTypeOptionGF()
        this.getEvaluateTypeOption()
    },
    methods: {
        btn_del(id) {
            this.$confirm('此操作将永久删除该维度, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                evaluateTypeDelete(id).then(res => {
                    console.log(res, 'evaluateTypeDelete');
                    this.$message.success('删除成功')
                    this.getEvaluateTypeOption()
                })
            }).catch(() => {

            });
        },
        // 新建维度
        openCreateWd() {
            this.$prompt('请输入评价维度', '新建评价维度', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,15}$/,
                inputErrorMessage: '不可超过15个字'
            }).then(({ value }) => {
                evaluateTypeAdd({
                    courseType: this.courseType,
                    typeName: value
                }).then(res => {
                    console.log(res, 'evaluateTypeAdd');
                    this.$message.success('添加成功')
                    this.getEvaluateTypeOption()
                })
            })
        },
        // 获取维度数据
        getEvaluateTypeOption() {
            evaluateTypeOption(this.courseType, 1).then(res => {
                console.log(res, 'evaluateTypeOption');
                res.data.forEach(item => {
                    item.show = false
                })
                this.wdList = res.data
            })
        },
        // 获取官方维度数据
        getEvaluateTypeOptionGF() {
            evaluateTypeOption(this.courseType, '0').then(res => {
                console.log(res, 'evaluateTypeOption');
                this.gfList = res.data
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.line1_ {
    white-space: pre-wrap;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
}

.body {
    width: 1200px;
    height: 0;
    flex: 1;
    // height: 100%;
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    box-sizing: border-box;
    padding: 10px 0;

    .left {
        width: 256px;
        height: 100%;
        // flex: 1;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 20px 10px;

        .l_tit {
            width: 100%;
            text-align: left;
            font-weight: 500;
            font-size: 18px;
            color: #11182F;
            margin-bottom: 20px;
        }

        .l_list {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;

            .ll_item {
                width: 100%;
                padding-bottom: 15px;
                border-bottom: 1px solid #E0E0E0;
                margin-bottom: 20px;

                .lli_top {
                    width: 100%;
                    display: flex;
                    align-items: center;

                    img {
                        width: 18px;
                        height: 18px;
                    }

                    div {
                        font-weight: 500;
                        font-size: 14px;
                        color: #11182F;
                        margin-left: 12px;
                    }
                }

                .lli_bottom {
                    font-weight: 400;
                    font-size: 12px;
                    color: #888888;
                    margin-top: 8px;
                }
            }
        }
    }

    .right {
        width: 934px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 20px;

        .r_tit {
            font-weight: 500;
            font-size: 18px;
            color: #11182F;
        }

        .r_tit1 {
            font-weight: 400;
            font-size: 14px;
            color: #A2A3A4;
            margin-top: 12px;
        }

        .r_add {
            width: 118px;
            height: 44px;
            background: #FFFFFF;
            box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.04);
            border-radius: 4px;
            border: 1px solid #E1E2E4;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            margin-top: 30px;
            margin-bottom: 38px;
            user-select: none;
            cursor: pointer;

            img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }

        .r_list {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;
            display: flex;
            align-items: center;
            align-content: flex-start;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 20px;

            .nodata {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 16px;
                color: #898B8F;
                margin-top: 40px;

                img {
                    width: 320px;
                    height: 240px;
                    margin-bottom: 20px;
                }
            }

            .rl_item {
                width: 431px;
                height: 165px;
                background: #FFFFFF;
                box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.11);
                border-radius: 9px;
                border: 1px solid #E1E2E4;
                display: flex;
                align-items: flex-start;
                box-sizing: border-box;
                padding: 15px 20px;
                margin-bottom: 20px;
                position: relative;

                .menu {
                    width: 144px;
                    height: 116px;
                    background: #FFFFFF;
                    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.11);
                    border-radius: 6px;
                    border: 1px solid #E1E2E4;
                    box-sizing: border-box;
                    padding: 0 10px;
                    position: absolute;
                    right: -97px;
                    top: 50px;

                    .m_item {
                        width: 100%;
                        height: 50%;
                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        padding: 0 8px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        user-select: none;
                        cursor: pointer;

                        img {
                            width: 13px;
                            height: 13px;
                            margin-right: 12px;
                        }
                    }
                }

                .rli_left {
                    width: 20px;
                    height: 20px;
                }

                .rli_right {
                    flex: 1;
                    margin-left: 12px;

                    .lir_top {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 10px;

                        div {
                            font-weight: 500;
                            font-size: 14px;
                            color: #333333;
                        }

                        img {
                            width: 13px;
                            height: 13px;
                            cursor: pointer;
                        }
                    }

                    .lir_bottom {
                        width: 100%;
                        word-break: break-all;
                        display: -webkit-box;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 6;
                        -webkit-box-orient: vertical;
                        font-weight: 400;
                        font-size: 12px;
                        color: #888888;
                    }
                }
            }
        }
    }
}
</style>